import React, { useState, useEffect, useRef } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { Col, Row, Card, CardBody, Button } from "reactstrap";
import { Fn_AddEditData, Fn_DisplayData } from "../../store/Functions";
import { useDispatch } from "react-redux";
import { API_WEB_URLS } from "../../constants/constAPI";
import { useLocation, useNavigate } from "react-router-dom";
import { Save, ArrowLeft } from "react-feather";

const POPULAR_EMOJIS = [
  "📦", "📄", "💻", "🍷", "🍎", "👕", "🛋️", "🔨", "🛒", "💊", "🧱", "🛵", "🚲", "🚗", "🧺", "📚", "🥩", "🍼", "🧁", "🌾"
];

function AddEdit_GoodsTypeMaster() {
  const API_URL_SAVE = "GoodsTypeMaster/0/token";
  const API_URL_EDIT = `${API_WEB_URLS.MASTER}/0/token/GoodsTypeMaster/Id`;

  const [state, setState] = useState({
    id: 0,
    formData: {
      Name: "",
      Icon: "📦",
      Description: "",
      DisplayOrder: 0,
      IsActive: true,
    },
  });

  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const nameRef = useRef(null);

  useEffect(() => {
    const Id = (location.state && location.state.Id) || 0;
    if (Id > 0) {
      setState((prev) => ({ ...prev, id: Id }));
      Fn_DisplayData(dispatch, setState, Id, API_URL_EDIT);
    }
  }, [dispatch, location.state]);

  useEffect(() => {
    if (nameRef.current) {
      nameRef.current.focus();
    }
  }, []);

  const validationSchema = Yup.object({
    Name: Yup.string().trim().required("Goods Type Name is required"),
    DisplayOrder: Yup.number().typeError("Display Order must be a number").min(0, "Cannot be negative"),
  });

  const handleSubmit = async (values) => {
    const userObj = JSON.parse(localStorage.getItem("user") || "{}");
    const formData = new FormData();
    formData.append("Name", values.Name.trim());
    formData.append("Icon", values.Icon || "📦");
    formData.append("Description", values.Description || "");
    formData.append("DisplayOrder", values.DisplayOrder || 0);
    formData.append("IsActive", values.IsActive === true || values.IsActive === "true" || values.IsActive === 1);
    formData.append("UserId", userObj?.uid || 0);

    Fn_AddEditData(
      dispatch,
      setState,
      { arguList: { id: state.id, formData } },
      API_URL_SAVE,
      true,
      "memberid",
      navigate,
      "/GoodsTypeMaster"
    );
  };

  return (
    <div style={{ padding: "8px 12px", maxWidth: 850, margin: "0 auto" }}>
      <Card className="border shadow-sm">
        <CardBody className="p-3">
          {/* Header */}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              marginBottom: 12,
              paddingBottom: 8,
              borderBottom: "1.5px solid #dee2e6",
            }}
          >
            <div className="d-flex align-items-center gap-2">
              <span
                style={{
                  width: 32,
                  height: 32,
                  borderRadius: "50%",
                  backgroundColor: "#fff3cd",
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: "1.1rem",
                }}
              >
                📦
              </span>
              <div>
                <h6 className="mb-0 fw-bold text-dark">
                  {state.id > 0 ? "Edit Goods Type" : "Add New Goods Type"}
                </h6>
                <small className="text-muted">Configure goods/cargo category selectable in apps</small>
              </div>
            </div>

            <div style={{ display: "flex", gap: 8 }}>
              <Button
                type="button"
                size="sm"
                color="light"
                className="py-1 px-3 d-flex align-items-center gap-1 border"
                onClick={() => navigate("/GoodsTypeMaster")}
              >
                <ArrowLeft size={13} />
                <span>Back</span>
              </Button>
              <Button
                type="submit"
                form="goods-type-form"
                size="sm"
                color="primary"
                className="py-1 px-3 d-flex align-items-center gap-1 fw-semibold"
              >
                <Save size={13} />
                <span>Save Goods Type</span>
              </Button>
            </div>
          </div>

          <Formik
            initialValues={{
              Name: state.formData.Name || "",
              Icon: state.formData.Icon || "📦",
              Description: state.formData.Description || "",
              DisplayOrder: state.formData.DisplayOrder != null ? state.formData.DisplayOrder : 0,
              IsActive: state.formData.IsActive !== undefined ? state.formData.IsActive : true,
            }}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
            enableReinitialize={true}
          >
            {({ errors, touched, values, setFieldValue }) => (
              <Form id="goods-type-form" className="mt-2">
                <Row className="g-3">
                  {/* Name */}
                  <Col md={8}>
                    <label className="form-label small fw-bold mb-1">
                      Goods Type Name <span className="text-danger">*</span>
                    </label>
                    <Field
                      innerRef={nameRef}
                      className={`form-control form-control-sm ${errors.Name && touched.Name ? "is-invalid" : ""}`}
                      type="text"
                      name="Name"
                      placeholder="e.g. Electronics & Appliances, Documents, Food Items..."
                    />
                    <ErrorMessage name="Name" component="div" className="invalid-feedback d-block small" />
                  </Col>

                  {/* Display Order */}
                  <Col md={4}>
                    <label className="form-label small fw-bold mb-1">
                      Display Order (Sort Index)
                    </label>
                    <Field
                      className={`form-control form-control-sm ${errors.DisplayOrder && touched.DisplayOrder ? "is-invalid" : ""}`}
                      type="number"
                      name="DisplayOrder"
                      placeholder="0"
                    />
                    <ErrorMessage name="DisplayOrder" component="div" className="invalid-feedback d-block small" />
                  </Col>

                  {/* Icon / Emoji */}
                  <Col md={6}>
                    <label className="form-label small fw-bold mb-1">
                      Visual Icon / Emoji
                    </label>
                    <div className="input-group input-group-sm mb-1.5">
                      <span className="input-group-text bg-white fs-5" style={{ minWidth: 44, textAlign: "center" }}>
                        {values.Icon || "📦"}
                      </span>
                      <Field
                        className="form-control form-control-sm"
                        type="text"
                        name="Icon"
                        placeholder="Paste emoji or icon code (e.g. 📦)"
                      />
                    </div>
                    {/* Quick Emoji Pickers */}
                    <div className="d-flex flex-wrap gap-1 mt-1 p-1 bg-light rounded border">
                      {POPULAR_EMOJIS.map((emoji) => (
                        <button
                          key={emoji}
                          type="button"
                          className={`btn btn-sm py-0 px-1 ${values.Icon === emoji ? "btn-primary" : "btn-light"}`}
                          style={{ fontSize: "1rem" }}
                          onClick={() => setFieldValue("Icon", emoji)}
                          title={`Select ${emoji}`}
                        >
                          {emoji}
                        </button>
                      ))}
                    </div>
                  </Col>

                  {/* Status (IsActive) */}
                  <Col md={6}>
                    <label className="form-label small fw-bold mb-1">
                      Status
                    </label>
                    <Field
                      as="select"
                      className="form-select form-select-sm"
                      name="IsActive"
                      value={String(values.IsActive)}
                      onChange={(e) => setFieldValue("IsActive", e.target.value === "true")}
                    >
                      <option value="true">Active (Visible in Customer App)</option>
                      <option value="false">Inactive (Hidden)</option>
                    </Field>
                  </Col>

                  {/* Description */}
                  <Col md={12}>
                    <label className="form-label small fw-bold mb-1">
                      Description / Handling Instructions (Optional)
                    </label>
                    <Field
                      as="textarea"
                      rows={3}
                      className="form-control form-control-sm"
                      name="Description"
                      placeholder="e.g. Glass, delicate items requiring cushion packaging..."
                    />
                  </Col>
                </Row>
              </Form>
            )}
          </Formik>
        </CardBody>
      </Card>
    </div>
  );
}

export default AddEdit_GoodsTypeMaster;
